module.exports = __webpack_public_path__ + "static/img/Zyon-Maiu_u.6fcd1b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Zyon-Maiu_u.jpg
// module id = PqCh
// module chunks = 0